import { EventInfo, ListComponentItemType, ListComponentProps, UserInfo } from "@/types";
import { api_url } from "@/variables";
import axios from "axios";
import { useEffect, useState } from "react";
import ListBoxComponent from "./list-box-component";
import SplitterComponent from "./splitter-component";
import UserDisplayComponent from "./user-display-component";
import { Box, Stack } from "@chakra-ui/react";
import { useWindowSize } from "@uidotdev/usehooks"
import EventDisplayComponent from "./event-display-component";

const UserListComponent = (props: ListComponentProps) => {

    props.itemType == ListComponentItemType.UserInfo ? console.log("user list loaded") : console.log("event list loaded")


    const [itemList, updateItemList] = useState<UserInfo[] | EventInfo[]>([])
    const [loadingUsers, setLoadingUsers] = useState(true)
    const [activeUser, setActiveUser] = useState<UserInfo | EventInfo | null>(null)

    const size: {width: number | null, height: number | null } = useWindowSize()

    const typeIsUserInfo: boolean = props.itemType == ListComponentItemType.UserInfo ? true : false

    useEffect(() => {
        const getUsers = async () => {
            try {
                const response = await axios.get(`${api_url}/${typeIsUserInfo ? 'users' : 'events'}`, 
                );
                
                if( response.data != "" ) {
                    if ( !typeIsUserInfo ) {
                        console.log("events response")
                        console.log(response.data)
                    }
                    updateItemList(response.data)
                }

                setLoadingUsers(false)

            } catch (error) {
                console.error(error);
            }

        };
        getUsers()   
    }, [])

    const onValueChange = (details: any) => {
        if( typeIsUserInfo ) {
            const currUser: UserInfo | EventInfo = itemList.filter((e: UserInfo | EventInfo) => (e as UserInfo).telegram_id == details.value)[0]
            setActiveUser(currUser as UserInfo)
        } else if( !typeIsUserInfo ) {
            console.log("event on change details")
            console.log(details)
            const currUser: UserInfo | EventInfo = itemList.filter((e: UserInfo | EventInfo) => (e as EventInfo).event_id == details.value)[0]
            setActiveUser(currUser as EventInfo)
        } else {
            throw new TypeError("not implemented")
        }
    }

    
    const width: number = size.width == null ? 0 : size.width

    




    return (
        <>
            {!loadingUsers && width >= 670 &&
                <>
                { typeIsUserInfo  ?
                    <SplitterComponent>
                        <Box width="95%" height="95%">
                            <ListBoxComponent itemList={itemList as UserInfo[]} onValueChange={onValueChange} itemListType={props.itemType}/>
                        </Box>
                        <Box width="95%" height="95%">
                            <UserDisplayComponent user={activeUser == null ? (itemList[0] as UserInfo) : activeUser as UserInfo} />
                        </Box>
                    </SplitterComponent>
                :
                    <SplitterComponent>
                        <Box width="95%" height="95%">
                            <ListBoxComponent itemList={itemList as EventInfo[]} onValueChange={onValueChange} itemListType={props.itemType}/>
                        </Box>
                        <Box width="95%" height="95%">
                            <UserDisplayComponent user={activeUser == null ? (itemList[0] as UserInfo) : activeUser as UserInfo} />
                        </Box>
                    </SplitterComponent>
                }
                </>
                    
            }
            {!loadingUsers && width < 670 &&
                <>
                { typeIsUserInfo ?
                <Stack>
                    <Box marginTop="0px">
                        <ListBoxComponent itemList={itemList as UserInfo[]} itemListType={ListComponentItemType.UserInfo} onValueChange={onValueChange} />
                    </Box>
                    <UserDisplayComponent user={activeUser == null ? (itemList[0] as UserInfo) : activeUser as UserInfo} />
                </Stack>
                :
                <Stack>
                    <Box marginTop="0px">
                        <ListBoxComponent itemList={itemList as UserInfo[]} itemListType={ListComponentItemType.EventInfo} onValueChange={onValueChange} />
                    </Box>
                    <EventDisplayComponent event={activeUser == null ? (itemList[0] as EventInfo) : activeUser as EventInfo} />
                </Stack>
                }
                </>
            }
        </>
    )
}

export default UserListComponent


